import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  Button,
  Card,
  CardActions,
  CardHeader,
  CardContent,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
  Grid,
  Typography
} from '@mui/material'
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import { usuarioAction } from '../../../_actions'
import {
  ValidatorForm,
  TextValidator
} from 'react-material-ui-form-validator'
import { stringUtils } from '../../../utils'
import CustomButton from '../../../components/CustomButton/CustomButton'

export const UsuarioResponsavelAddModal = ({ modal, toggle, props, setResponsibleRegistereds }) => {

  const formRef = React.createRef(null);

  const dispatch = useDispatch()
  const { classes, className, empresa, ...rest } = props
  const { match: { params } } = props;
  const [nome, setNome] = useState('');
  const [cargo, setCargo] = useState('');

  const handleClose = () => {
    toggle();
  }

  const handleAddResponsavel = () => {
    setResponsibleRegistereds((prevItems) => [
      ...prevItems,
      { usuario: nome, cargo: cargo }
    ]);

    toggle();
  };

  function InsertText() {
    return (
      <Typography variant="h5">
        <b>{'Novo Responsável'}</b>
      </Typography>
    )
  }

  function SegHeader() {
    return <InsertText />
  }

  return (
    <Dialog
      open={modal}
      fullWidth
      style={{ padding: 0, margin: 0 }}
      maxWidth='md'
      onClose={toggle}
    >
      <DialogTitle align="right" style={{ paddingTop: 0, marginTop: 0, marginBottom: 0, paddingBottom: 0 }}>
        <Button
          variant="contained"
          style={{ backgroundColor: '#000', position: 'relative', marginTop: 15 }}
          onClick={() => handleClose()}>
          <CloseIcon />
        </Button>
      </DialogTitle>
      <DialogContent style={{ padding: 0, margin: 0 }}>
        <Card style={{ marginTop: 0 }}>
          <ValidatorForm
            style={{ marginTop: 0, paddingTop: 0 }}
            ref={formRef}
            id="formUsuario"
            onSubmit={handleAddResponsavel}
          >
            <CardHeader
              style={{ marginTop: 0, paddingTop: 0 }}
              subheader="Cadastro de Responsáveis"
              title={<SegHeader />}
            />
            <Divider />
            <CardContent lg={12} md={12} xl={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={6} md={6} xl={6} xs={12}>
                  <TextValidator
                    className={classes.textField}
                    fullWidth
                    id="nome"
                    label="Nome *"
                    margin="normal"
                    onInput={stringUtils.toInputUppercase}
                    onChange={(e) => setNome(e.target.value)}
                    value={nome || ''}
                    variant="outlined"
                    validators={['required']}
                    errorMessages={['Campo obrigatório!']}
                  />
                </Grid>
                <Grid item lg={6} md={6} xl={6} xs={12}>
                  <TextValidator
                    className={classes.textField}
                    fullWidth
                    id="cargo"
                    label="Cargo *"
                    margin="normal"
                    onInput={stringUtils.toInputUppercase}
                    onChange={(e) => setCargo(e.target.value)}
                    value={cargo || ''}
                    variant="outlined"
                    validators={['required']}
                    errorMessages={['Campo obrigatório!']}
                  />
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <CardActions>
              <Grid container lg={12} md={12} xl={12} xs={12}>
                <Typography style={{ fontSize: "10px", paddingLeft: "6px" }}>
                  * Campos obrigatórios
                </Typography>
              </Grid>
              <Grid container style={{
                display: 'flex',
                alignItems: 'end',
                flexDirection: 'row',
                textAlign: 'end',
                justifyContent: 'end'
              }}>
                <CustomButton
                  variant="outlined"
                  style={{ color: '#000', borderColor: '#000' }}
                  onClick={toggle}
                >
                  Cancelar
                </CustomButton>
                <CustomButton
                  type="submit"
                  dark={true}
                  variant="contained"
                  startIcon={<SaveIcon />}
                  endIcon={props.usuario.isLoading && <CircularProgress size={24} />}
                >
                  {props.usuario.isLoading ? 'Salvando responsável...' : 'Salvar'}
                </CustomButton>
              </Grid>
            </CardActions>
          </ValidatorForm>
        </Card>
      </DialogContent>
    </Dialog >
  )
}
